.AccordionPage {
  --hover-color: transparent;
  --title-color: var(--primary);
  --content-padding: 0 2rem;

  padding: 0 clamp(4rem, 8vw, 12rem);
  gap: 2rem;
  display: flex;
  flex-direction: column;
  box-shadow: unset;
}

.AccordionPage__section {
  padding: 1rem 0;
}

.AccordionPage__section-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
